// extracted by mini-css-extract-plugin
module.exports = {"container":"AppleLoginButton_container__VaN_x","icon":"AppleLoginButton_icon__2qApl","disabled":"AppleLoginButton_disabled__2w2Nv"};